<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" :titulo="titulo" style="flex: 1 0 100%;" />
    <div slot="menu" class="menucontextual">
      <section v-if="hasAvisoRenovacion">
        <a href="#" @click.prevent="gotoAvisoRenovacion(poliza.idPoliza)" class="linkTituloSeccion">
          <div class="tituloSeccion">
            <span>
              <fai :icon="['fas', 'angle-right']" class="fa-fw" />
            </span>
            <span class="tituloSeccionBlinker">
              {{ "Aviso de Renovación" }}
            </span>
          </div>
        </a>
      </section>
      <SeccionOcultable v-if="haySiniestros" titulo="Últimos expedientes">
          <SeccionOcultable v-if="lstSiniestrosAbiertos.length > 0" titulo="Abiertos" class="segundoNivel">
                <ul>    
                  <li v-for="siniestro in lstSiniestrosAbiertos" :key="siniestro.numSiniestro"
                    @click.prevent="gotoSiniestroMov(siniestro.numSiniestro)">
                    <a href="#">{{ siniestro.numSiniestro }}</a>
                  </li>
                </ul>
         </SeccionOcultable>
         <SeccionOcultable v-if="lstSiniestrosCerrados.length > 0" titulo="Cerrados" class="segundoNivel">
                <ul>
                  <li v-for="siniestro in lstSiniestrosCerrados" :key="siniestro.numSiniestro"
                    @click.prevent="gotoSiniestroMov(siniestro.numSiniestro)">
                    <a href="#">{{ siniestro.numSiniestro }}</a>
                  </li>
                </ul>
         </SeccionOcultable>
      </SeccionOcultable>
      <SeccionOcultable v-if="poliza.nsg('lstRecibosPdtes.length')" titulo="Recibos pendientes">
        <ul>
          <li v-for="recibo in poliza.lstRecibosPdtes" :key="recibo.idRecibo"
            @click.prevent="gotoRecibo(recibo.idRecibo)">
            <EnlaceRecibo :recibo="recibo" />
          </li>
        </ul>
      </SeccionOcultable>

      <SeccionOcultable v-if="poliza.nsg('lstRecibosCob.length')" titulo="Recibos">
        <ul>
          <li v-for="recibo in poliza.lstRecibosCob" :key="recibo.idRecibo" @click.prevent="gotoRecibo(recibo.idRecibo)">
            <EnlaceRecibo :recibo="recibo" />
          </li>
        </ul>
      </SeccionOcultable>

      <SeccionOcultable v-if="poliza.nsg('lstRecibosFuturos.length')" titulo="Recibos Futuros">
        <ul>
          <li v-for="recibo in poliza.lstRecibosFuturos" :key="recibo.idRecibo"
            @click.prevent="gotoRecibo(recibo.idRecibo)">
            <EnlaceRecibo :recibo="recibo" />
          </li>
        </ul>
      </SeccionOcultable>
      <SeccionOcultable titulo="Documentación">
        <ul>
          <li v-if="ccppActual">
            <a href="#" target="_blank" class="ripple" @click.prevent="verCondicionadoActual()">
              Contrato de seguro
              <br />
              <label class="noDisponibleCCPP" v-if="noDisponibleCCPPActual">
                No disponible en formato digital. <br />
                Contacte con MMT Seguros.
              </label></a>
          </li>
          <li v-if="ccppFuturo">
            <a href="#" target="_blank" class="ripple" @click.prevent="verCondicionadoFuturo()">
              Contrato de seguro {{ ccppFuturo.fechaEfecto }}
              <br />
              <label class="noDisponibleCCPP" v-if="noDisponibleCCPPFuturo">
                No disponible en formato digital. <br />
                Contacte con MMT Seguros.
              </label></a>
          </li>

          <li>
            <a class="enlace"
              href="https://www.mmtseguros.com/hubfs/Informacion_Corporativa/Estatutos-Sociales-2025.pdf?hsLang=es-es"
              target="_blank">Estatutos sociales</a>
          </li>
        </ul>
      </SeccionOcultable>
    </div>

    <div v-if="poliza" slot="contenido" class="tarjetario">
      <Asegurados v-if="isProyectoMovilidadPersonal" :asegurados="poliza.asegurados" />
      <VehiculoVPM v-if="isProyectoVMP" :poliza="poliza" />
      <Tomador :poliza="poliza" />
      <Contrato :poliza="poliza" />
      <ConductorMovilidad v-if="isProyectoVMP" :conductor="poliza.conductor" />
      <DatosBancarios :poliza="poliza" />

    </div>
  </TemplateConMenuLateral>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      noDisponibleCCPPActual: false,
      noDisponibleCCPPFuturo: false,
    };
  },
  computed: {
    poliza() {
      return this.$store.state.seleccion;
    },

    haySiniestros() {
      return this.poliza.nsg("lstSiniestrosMov.length");
    },

    lstSiniestrosAbiertos() {
      return this.poliza.lstSiniestrosMov.filter(sini => sini.estado.toUpperCase() === 'ABIERTO');
    },

   lstSiniestrosCerrados() {
      return this.poliza.lstSiniestrosMov.filter(sini => sini.estado.toUpperCase() !== 'ABIERTO');
   },

    hasAvisoRenovacion() {
      return this.poliza.nsg("tenemosAvisoCobro");
    },

    isProyectoVMP() {
      return this.poliza.nsg("esProyectoVMP") == "S";
    },

    isProyectoMovilidadPersonal() {
      return this.poliza.nsg("esProyectoMovilidadPersonal") == "S";
    },

    titulo() {
      return "Póliza: " + this.poliza.nsg("numPoliza");
    },
    ccppActual() {
      for (let indice in this.poliza.lstCCPP) {
        if (this.poliza.lstCCPP[indice].tipo == "ACTUAL") {
          return this.poliza.lstCCPP[indice];
        }
      }
      return null;
    },

    ccppFuturo() {
      for (let indice in this.poliza.lstCCPP) {
        if (this.poliza.lstCCPP[indice].tipo == "FUTURO") {
          return this.poliza.lstCCPP[indice];
        }
      }
      return null;
    },
  },

  beforeRouteEnter: async function (to, from, next) {
    await fetchData(to.params.idPoliza);
    next();
  },

  beforeRouteUpdate: async function (to, from, next) {
    await fetchData(to.params.idPoliza);
    next();
  },

  methods: {
    gotoRecibo(idRecibo) {
      this.$router.push({
        name: "recibo",
        params: { idRecibo: idRecibo },
      });
    },

    gotoAvisoRenovacion(idPoliza) {
      this.$router.push({
        name: "avisoRenovacion",
        params: { idPoliza: idPoliza },
      });
    },

    gotoSiniestroMov(numSiniestro) {
      this.$router.push({
        name: "siniestroMovilidad",
        params: { numSiniestro: numSiniestro },
      });
    },

    dowloadDocumento: async function (ccpp) {
      if (
        ccpp.nsg("estado") == "DIGITAL_CERTIFICADA" &&
        ccpp.nsg("mimeType") == "application/pdf"
      )
        this.$store.dispatch("dowloadDocumento", ccpp.uuid);
    },

    verCondicionadoActual() {
      if (
        this.ccppActual != null &&
        this.ccppActual.nsg("estado") == "DIGITAL_CERTIFICADA" &&
        this.ccppActual.nsg("mimeType") == "application/pdf"
      )
        this.dowloadDocumento(this.ccppActual);
      else this.noDisponibleCCPPActual = true;
    },

    verCondicionadoFuturo() {
      if (
        this.ccppFuturo != null &&
        this.ccppFuturo.nsg("estado") == "DIGITAL_CERTIFICADA" &&
        this.ccppFuturo.nsg("mimeType") == "application/pdf"
      )
        this.dowloadDocumento(this.ccppFuturo);
      else this.noDisponibleCCPPFuturo = true;
    },

    getUrlDoc(tipoDoc) {
      return null;
    },

  },
};

import store from "@/store/store.js";
async function fetchData(idPoliza) {
  await store.dispatch("getPolizaMovilidad", idPoliza);
}
</script>

<style lang="scss" scoped>
.linkTituloSeccion {
  text-decoration: none;

  :hover {
    text-decoration: none;
    cursor: pointer;
  }

  :active {
    text-decoration: none;
    cursor: pointer;
  }
}

.tituloSeccion {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 0.75rem;
  font-weight: normal;
}

.tituloSeccionBlinker {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 0.75rem;
  font-weight: normal;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.noDisponibleCCPP {
  font-size: 85%;
  color: cyan;
}

.segundoNivel {
  margin-left: 1rem;
}
</style>
